module.exports = __webpack_public_path__ + "static/img/channel-name.540652f8.png";